import React, { useEffect, useState } from "react";

const ICONS = {
  info: (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
      <path fillRule="evenodd" d="M18 10A8 8 0 11 2 10a8 8 0 0116 0zm-9-1a1 1 0 10-2 0v5a1 1 0 102 0V9zm0-3a1 1 0 10-2 0 1 1 0 002 0z" clipRule="evenodd" />
    </svg>
  ),
  success: (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
    </svg>
  ),
  error: (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm-1-9V7a1 1 0 112 0v2a1 1 0 11-2 0zm0 4a1 1 0 112 0 1 1 0 11-2 0z" clipRule="evenodd" />
    </svg>
  ),
  warn: (
    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 20 20" fill="currentColor">
      <path fillRule="evenodd" d="M8.257 3.099c.763-1.36 2.722-1.36 3.485 0l6.518 11.62c.75 1.337-.213 2.98-1.742 2.98H3.48c-1.529 0-2.492-1.643-1.742-2.98L8.257 3.1zM11 13a1 1 0 10-2 0 1 1 0 002 0zm-1-8a1 1 0 00-.993.883L9 6v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
    </svg>
  )
};

function HotToastMessage({ message, type, duration, onClose, position }) {
  const [visible, setVisible] = useState(Boolean(message));

  useEffect(() => {
    if (message) {
      setVisible(true);
    }
  }, [message]);

  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(() => {
      setVisible(false);
      if (typeof onClose === "function") onClose();
    }, duration);
    return () => clearTimeout(t);
  }, [visible, duration, onClose]);

  if (!message || !visible) return null;

  const bgByType = {
    info: "bg-blue-50 border-blue-200 text-blue-800",
    success: "bg-green-50 border-green-200 text-green-800",
    error: "bg-red-50 border-red-200 text-red-800",
    warn: "bg-yellow-50 border-yellow-200 text-yellow-800",
  };

  const containerPosition =
    position === "bottom"
      ? "fixed bottom-6 left-1/2 transform -translate-x-1/2"
      : "fixed top-6 left-1/2 transform -translate-x-1/2";

  return (
    <div
      className={`z-50 ${containerPosition} max-w-xl w-full px-4 transition-all duration-300 ease-in-out ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
      }`}
    >
      <div
        className={`mx-auto flex items-start gap-3 p-3 border rounded-2xl shadow-md ${bgByType[type] || bgByType.info}`}
        role="status"
        aria-live="polite"
      >
        <div className="flex-shrink-0">{ICONS[type] || ICONS.info}</div>
        <div className="flex-1 text-sm leading-tight">{message}</div>
        <button
          onClick={() => {
            setVisible(false);
            if (typeof onClose === "function") onClose();
          }}
          aria-label="close-toast"
          className="flex-shrink-0 p-1 rounded hover:bg-black/5"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-4 h-4"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 011.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
    </div>
  );
}

export default HotToastMessage;